import { Chip } from "@mui/material";
import { Datagrid, DateField, EditButton, ReferenceManyField, SimpleShowLayout, TextField, useRecordContext } from "react-admin";
import ScheduleIcon from '@mui/icons-material/Schedule'

export const CustomState =  ({ source }) => {
    const record = useRecordContext()
    if(!record) return null
    if(record[source]==="1") {
        return  <Chip label="Attivo" color="success" /> 
    } else if(record[source]==="0"){
        return  <Chip label="Non attivo" color="error" />
    } else {
        return  <Chip label="Sospeso" icon={<ScheduleIcon />} />
    }
}

export default function ImpiantiReferenceProdotti(){
    
    
    return (
        <SimpleShowLayout>
            <ReferenceManyField label="Prodotti"
                reference="prodotti"
                target="id_impianto" 
               >
                    <Datagrid>
                        <CustomState source="stato" />
                        <TextField source="id" label="ID Prodotto"/>
                        <TextField source="marca" />
                        <TextField source="modello" />
                        <TextField source="numero_serie" />
                        <TextField source="potenza" />
                        <DateField source="data_accensione" />
                        <TextField source="note" />
                        <EditButton label=""/>
                    </Datagrid>
            </ReferenceManyField>
        </SimpleShowLayout>
    )
}

